import { render, staticRenderFns } from "./clientSection.vue?vue&type=template&id=21ed8bc7&"
import script from "./clientSection.vue?vue&type=script&lang=js&"
export * from "./clientSection.vue?vue&type=script&lang=js&"
import style0 from "./clientSection.vue?vue&type=style&index=0&id=21ed8bc7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports